(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tf-apparel-banner"] && !Shopify.designMode) return;
  try {
    
  // iOS only honours autoplay when the video is muted and inline. Re-assert
  // these as properties (not just attributes) and swallow a rejected play()
  // so a refused autoplay leaves the poster frame rather than a black box.
  document.querySelectorAll('.tf-banner__video video').forEach(function (video) {
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute('playsinline', '');
    var attempt = video.play();
    if (attempt && typeof attempt.catch === 'function') {
      attempt.catch(function () {
        /* Autoplay refused (low power mode, data saver) — poster stays. */
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-hero"] && !Shopify.designMode) return;
  try {
    
  // iOS only honours autoplay when the video is muted and inline. Re-assert
  // these as properties (not just attributes) and swallow a rejected play()
  // so a refused autoplay leaves the poster frame rather than a black box.
  document.querySelectorAll('.video-hero__media video').forEach(function (video) {
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute('playsinline', '');
    var attempt = video.play();
    if (attempt && typeof attempt.catch === 'function') {
      attempt.catch(function () {
        /* Autoplay refused (low power mode, data saver) — poster stays. */
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
